import React, { useState, useEffect } from 'react';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Form,
  FormGroup,
  Input,
  Row,
  Col,
  FormFeedback,
  InputGroup, InputGroupText,
  Label,
  ListGroup,
  ListGroupItem,
} from 'reactstrap';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import Swal from 'sweetalert2';
import {
  DOCUMENT_VARIABLE_CREATE_URL,
  DOCUMENT_VARIABLE_UPDATE_URL,
} from '../../../utils/APIEndpoints';
import { authHeader } from '../../../utils/functions/CoreFunctions';
import API from '../../../redux/actions/API';
import { FLOAT_REGEX } from '../../../utils/constants/ValidationRegexs';
import {
  getAlertToast,
  SingleStringFirstLetterCaps,
} from '../../../utils/functions/CustomFunctions';
import CustomLoader from '../../common/CustomLoader';
import { useDispatch, useSelector } from 'react-redux';
import produce from 'immer';
import { STEP_2_UPDATE_DOCUMENTS_ARRAY } from '../../../redux/actions/ActionTypes';

const validationSchema = Yup.object({
  labelName: Yup.string().trim().required('Label name is required'),
  feeVariableTypeId: Yup.string().trim().required('Varibale Type is Required'),
  price: Yup.string().when('feeVariableTypeId', {
    is: (feeVariableTypeId) =>
      feeVariableTypeId == '3' ||
      feeVariableTypeId == '4' ||
      feeVariableTypeId == '5',
    then: Yup.string().notRequired(),
    otherwise: Yup.string()
      .required('Fee is Required')
      .trim()
      .max(10, 'Amount is Not Valid')
      .matches(FLOAT_REGEX, 'Enter valid fee'),
  }),
});

const CreateVariableDialog = (props) => {
  const {
    toggle,
    modal,
    formData = {},
    isAdd,
    saveCallBack,
    agencyServiceId,
    documentType,
    documentsList = [],
  } = props;

  const {
    formula = '',
    multichoiceDetails = '',
    multipleChoiceId = '',
  } = formData;

  const intialValue = JSON.parse(formula).map((x) => {
    return { labelName: x.labelName };
  });

  const [inputValues, setInputValues] = useState([
    { label: '', fee: '', id: '', isDelete: false, tempId: Date.now() },
  ]);

  const dispatch = useDispatch();

  const [btnLoading, setButtonLoading] = useState(false);
  const [buttonToggle, setButtonToggle] = useState(false);
  const [dropValue, setDropValue] = useState(0);
  const [subdropValue, setSubDropValue] = useState(0);
  const [errorHandel, seterrorHandel] = useState({});
  const [choosenArray, setChoosenArray] = useState(JSON.parse(formula));
  const [showValue, setShowValue] = useState(intialValue);
  const [multival, setMultival] = useState(0);
  const [flag, setFlag] = useState(false);
  const [operator, setOperator] = useState([
    {
      operatorId: 1,
      operatorName: 'Addition',
    },
    {
      operatorId: 2,
      operatorName: 'Multiply',
    },
  ]);
  const VariantsListReducer = useSelector((state) => state.VariantsListReducer);
  const { data = [] } = VariantsListReducer;

  useEffect(() => {
    if (multichoiceDetails != '' || inputValues.isDelete == false) {
      const intialValue1 = JSON.parse(multichoiceDetails || '[]').map(
        (item1, index) => {
          return {
            label: item1.labelName,
            fee: parseFloat(item1.fees || 0),
            id: item1.multipleChoiceId,
            isDelete: false,
            tempId: Date.now() + index + 1,
          };
        }
      );
      setInputValues(intialValue1);
    }
  }, [multichoiceDetails]);

  //Formik
  const {
    handleSubmit,
    handleChange,
    values,
    errors,
    touched,
    setFieldTouched,
    setFieldValue,
  } = useFormik({
    initialValues: {
      ...formData,
    },
    enableReinitialize: true,
    validationSchema,
    onSubmit: (values) => saveFormValues(values),
  });

 

  //On Submit
  const saveFormValues = async (values) => {
  
    // values.agencyServiceId = agencyServiceId;
    let error = {};
    let userList1 = [];
    let isRequired = false;
    if (values.feeVariableTypeId == 5) {
      inputValues.map((item1) => {
        if (!item1.isDelete) {
          if (!item1.label) {
            isRequired = true;
            error[item1.tempId] = { ...error[item1.tempId], label: 'Required' };
          }
          if (!item1.fee) {
            isRequired = true;
            error[item1.tempId] = { ...error[item1.tempId], fee: 'Required' };
          }
        }
        userList1.push({
          labelName: item1.label,
          fees: parseFloat(item1.fee),
          isDeleted: item1.isDelete,
        });
      });
    }
    seterrorHandel(error);
    if (isRequired) {
      return null;
    }
    let userList2 = [];
    inputValues.map((item1) => {
      userList2.push({
        multipleChoiceId: item1.id ? item1.id : 0,
        labelName: item1.label,
        fees: parseFloat(item1.fee),
        isDeleted: item1.isDelete,
      });
    });

    if (values.feeVariableTypeId == 4 && choosenArray.length == 0) {
      Swal.fire(getAlertToast('success', 'Please add operations'));
    } else {
      setButtonLoading(true);
      const options = {
        method: isAdd ? 'POST' : 'PUT',
        url: isAdd
          ? DOCUMENT_VARIABLE_CREATE_URL
          : DOCUMENT_VARIABLE_UPDATE_URL,
        headers: authHeader(),
        data: {
          feesId: isAdd ? 0 : values.feesId,
          agencyServiceId: agencyServiceId,
          labelName: values.labelName,
          price: multival
            ? multival
            : values.price
            ? parseFloat(values.price).toFixed(2)
            : 0 || 0,
          feeVariableTypeId: parseInt(values.feeVariableTypeId),
          formula: JSON.stringify(choosenArray),
          isNonDisplayVariable: values.isNonDisplayVariable,
          multipleChoiceDetails: isAdd ? userList1 : userList2,
        },
      };
      try {
        let response = await API(options);
        const { status, message } = response.data;
        if (status === 'Error') {
          Swal.fire(getAlertToast('error', message));
        } else {
          Swal.fire(
            getAlertToast(
              'success',
              isAdd
                ? 'Variable added successfully'
                : 'Variable details updated successfully'
            )
          );
          saveCallBack();

          let data = documentsList.map((item, index) => {
            const { elements = [] } = item;
            const elementItem = elements.map((i, ind) => {
              if (i.variableTypeId == values.feeVariableTypeId) {
                return {
                  ...i,
                  variableFee: values.price,
                  variableLabel: values.labelName,
                };
              } else {
                return { ...i };
              }
            });
            return { ...item, elements: elementItem };
          });

          dispatch({
            type: STEP_2_UPDATE_DOCUMENTS_ARRAY,
            payload: data,
          });
        }
      } catch (error) {
        if (error.response) {
          let { data } = error.response;
          Swal.fire(getAlertToast('error', data.message));
        }
      } finally {
        setButtonLoading(false);
      }
    }
  };

  const handleButtonToggle = () => {
    setButtonToggle(!buttonToggle);
  };

  //constant Validator
  const constantValidator = (value) => {
    if (
      (choosenArray.length > 0 &&
        choosenArray[choosenArray.length - 1].type === 'variable') ||
      (choosenArray.length > 0 &&
        choosenArray[choosenArray.length - 1].type === 'constant')
    ) {
      Swal.fire(getAlertToast('success', 'Please add operator'));
    } else {
      setChoosenArray([
        ...choosenArray,
        { type: 'constant', value: value, labelName: value },
      ]);
      endValidator([
        ...choosenArray,
        { type: 'constant', value: value, labelName: value },
      ]);
      setShowValue([...showValue, { labelName: value }]);
      setDropValue(0);
      setSubDropValue(0);
    }
  };

  //varibale-Operator Validator
  const varibaleOperatorValidator = (value, label, type) => {
    if (choosenArray.length == 0 && type == 'operator') {
      Swal.fire(
        getAlertToast('success', 'Please add variable or constant first')
      );
    } else if (
      choosenArray.length > 0 &&
      choosenArray[choosenArray.length - 1].type == 'variable' &&
      type == 'variable'
    ) {
      Swal.fire(getAlertToast('success', 'Please add operator'));
    } else if (
      choosenArray.length > 0 &&
      choosenArray[choosenArray.length - 1].type == 'constant' &&
      type == 'variable'
    ) {
      Swal.fire(getAlertToast('success', 'Please add operator'));
    } else if (
      choosenArray.length > 0 &&
      choosenArray[choosenArray.length - 1].type == 'operator' &&
      type == 'operator'
    ) {
      Swal.fire(getAlertToast('success', 'Please add variable or constant'));
    } else {
      setChoosenArray([
        ...choosenArray,
        { type: type, value: value, labelName: label },
      ]);
      endValidator([
        ...choosenArray,
        { type: type, value: value, labelName: label },
      ]);
      setShowValue([...showValue, { labelName: label }]);
      setDropValue(0);
      setSubDropValue(0);
    }
  };

  const endValidator = (arrayValue = []) => {
    //for checking end Operator
    if (
      arrayValue.length > 0 &&
      arrayValue[arrayValue.length - 1].type === 'operator'
    ) {
      setFlag(true);
    } else {
      setFlag(false);
    }
  };

  const overallValidator = (arrayValue = []) => {
    if (arrayValue.length > 0 && arrayValue[0].type === 'operator') {
      setFlag(true);
    } else {
      setFlag(false);
    }

    for (let step = 1; step < arrayValue.length; step++) {
      //comapre wrong order elements
      if (
        arrayValue[step - 1].type == arrayValue[step].type ||
        (arrayValue[step - 1].type == 'variable' &&
          arrayValue[step].type == 'constant') ||
        (arrayValue[step - 1].type == 'constant' &&
          arrayValue[step].type == 'variable' &&
          arrayValue[arrayValue.length - 1].type == 'operator') ||
        (arrayValue.length > 0 &&
          arrayValue[arrayValue.length - 1].type == 'operator')
      ) {
        setFlag(true);
      } else {
        setFlag(false);
      }
    }
    // setFlag(false);
  };

  const formValueChange = (e) => {
    const value = e.target.value;
    console.log('form', value);
    setMultival(value);
    //constant
    constantValidator(value);
  };

  const formListChange = (e) => {
    const { list_value, list_label, type } = e.currentTarget.dataset;
    // variable - operator
    varibaleOperatorValidator(list_value, list_label, type);
  };

  const removeShowValue = (i) => {
    const items = showValue.filter((item) => item != showValue[i]);
    const items1 = choosenArray.filter((item) => item != choosenArray[i]);
    setChoosenArray(items1);
    setShowValue(items);
    overallValidator(items1);
  };

  const removeDocument = (e) => {
    const { id } = e.target;

    const values = produce(inputValues, (draft) => {
      const index = draft.findIndex((todo) => todo.tempId == id);
      if (index !== -1) draft[index].isDelete = true;
    });

    // values[index][e.target.name] = e.target.value;
    setInputValues(values);
  };

  const AddNewDocument = () => {
    setInputValues([
      ...inputValues,
      { label: '', fee: '', isDelete: false, tempId: Date.now() },
    ]);
  };

  const inputhandleChange = (e) => {
    const { value, id, name } = e.target;
    let errorRemove = { ...errorHandel };
    if (name == 'fee') {
      if (!/[^0-9\.]/g.test(value)) {
        const values = produce(inputValues, (draft) => {
          const index = draft.findIndex((todo) => todo.tempId == id);
          if (index !== -1) {
            draft[index][name] = value;
            errorRemove[id] = { ...errorRemove[id], [name]: '' };
          }
        });
        seterrorHandel(errorRemove);
        setInputValues(values);
      }
    } else {
      const values = produce(inputValues, (draft) => {
        const index = draft.findIndex((todo) => todo.tempId == id);
        if (index !== -1) {
          draft[index][name] = value;
          errorRemove[id] = { ...errorRemove[id], [name]: '' };
        }
      });
      seterrorHandel(errorRemove);
      setInputValues(values);
    }
  };

  console.log(errorHandel);
  return (
    <div>
      <Modal
        isOpen={modal}
        toggle={toggle}
        className="viewAgency"
        style={{ maxWidth: '600px' }}
        backdrop="static"
      >
        <ModalHeader toggle={toggle}>
          {isAdd ? 'Create Variable' : 'Update Variable'}
        </ModalHeader>
        <Form onSubmit={handleSubmit}>
          <ModalBody>
            <Row>
              <Col md={12}>
                <FormGroup>
                  <Label for="labelName">Label Name</Label>
                  <Input
                    type="text"
                    name="labelName"
                    id="labelName"
                    placeholder="Label Name"
                    invalid={
                      errors.labelName && touched.labelName ? true : false
                    }
                    onChange={({ target: { value } }) => {
                      setFieldTouched('labelName', true);
                      setFieldValue(
                        'labelName',
                        SingleStringFirstLetterCaps(value)
                      );
                    }}
                    value={values.labelName}
                  />
                  <FormFeedback>
                    {errors.labelName && touched.labelName
                      ? errors.labelName
                      : ''}
                  </FormFeedback>
                </FormGroup>
              </Col>
              <Col md={12}>
                <FormGroup>
                  <Label for="feeVariableTypeId">Variable Type</Label>
                  <Input
                    type="select"
                    name="feeVariableTypeId"
                    id="feeVariableTypeId"
                    value={values.feeVariableTypeId}
                    invalid={
                      errors.feeVariableTypeId && touched.feeVariableTypeId
                        ? true
                        : false
                    }
                    onChange={({ target: { value } }) => {
                      setFieldTouched('feeVariableTypeId', true);
                      setFieldValue('feeVariableTypeId', value);
                    }}
                  >
                    <option>Choose Variable Type</option>
                    <option value="1">Single Product</option>
                    <option value="2">Multi Product</option>
                    <option value="3">User Amount</option>
                    <option value="4">Multi Operation</option>
                    {!(documentType == 'Pdf') && (
                      <option value="5">
                        Single Product (Multiple Choice)
                      </option>
                    )}
                  </Input>
                  <FormFeedback>
                    {errors.feeVariableTypeId && touched.feeVariableTypeId
                      ? errors.feeVariableTypeId
                      : ''}
                  </FormFeedback>
                </FormGroup>

                {values.feeVariableTypeId == 5 &&
                  inputValues
                    .filter((filt) => filt.isDelete == false)
                    .map((values, index) => {
                      const { label, fee } = errorHandel[values.tempId] || {};
                      return (
                        <div key={index}>
                          <Row>
                            <Col md={5}>
                              <FormGroup>
                                <Label for="Label">Label</Label>
                                <InputGroup>
                                  <Input
                                    type="text"
                                    name="label"
                                    id={values.tempId}
                                    placeholder="label name"
                                    onChange={inputhandleChange}
                                    value={values.label}
                                  />
                                </InputGroup>
                                <FormFeedback
                                  style={{ display: 'block', color: 'red' }}
                                >
                                  {label}
                                </FormFeedback>
                              </FormGroup>
                            </Col>

                            <Col md={5}>
                              <FormGroup>
                                <Label for="price">Fee ($)</Label>
                                <InputGroup>
                                  
                                    <InputGroupText>$</InputGroupText>
                                  
                                  <Input
                                    type="text"
                                    name="fee"
                                    id={values.tempId}
                                    placeholder="fee"
                                    onChange={inputhandleChange}
                                    value={values.fee}
                                  />
                                </InputGroup>
                                <FormFeedback
                                  style={{ display: 'block', color: 'red' }}
                                >
                                  {fee}
                                </FormFeedback>
                              </FormGroup>
                            </Col>

                            {inputValues.filter(
                              (filt) => filt.isDelete == false
                            ).length > 1 && (
                              <Col md={2}>
                                <i
                                  id={values.tempId}
                                  className="fas fa-trash"
                                  style={{
                                    color: '#c72e39',
                                    margin: '12px',
                                    fontSize: '16px',
                                    cursor: 'pointer',
                                    'margin-top': '2.7rem',
                                  }}
                                  onClick={removeDocument}
                                />
                              </Col>
                            )}
                          </Row>
                        </div>
                      );
                    })}
                {values.feeVariableTypeId == 5 && (
                  <Row>
                    <Col md={2}>
                      <Button color="primary" onClick={AddNewDocument}>
                        <i className="fas fa-plus" /> Add
                      </Button>
                    </Col>
                    <Col md={9} />
                  </Row>
                )}

                {values.feeVariableTypeId == 4 && (
                  <section>
                    <div className="mutli-value-select">
                      <div style={{ marginBottom: '10px' }} className="row">
                        <Col md="6">
                          <Button color="primary" onClick={handleButtonToggle}>
                            ADD
                          </Button>
                        </Col>
                      </div>

                      {buttonToggle ? (
                        <Row>
                          <Col md="6">
                            <ListGroup>
                              <ListGroupItem tag="button" disabled>
                                Select category
                              </ListGroupItem>
                              <ListGroupItem
                                active={dropValue == 1}
                                onClick={() => setDropValue(1)}
                              >
                                Variable
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="4.418"
                                  height="7.726"
                                  viewBox="0 0 4.418 7.726"
                                >
                                  <path
                                    id="Icon_ionic-ios-arrow-forward"
                                    data-name="Icon ionic-ios-arrow-forward"
                                    d="M14.332,10.058,11.409,7.137a.55.55,0,0,1,0-.78.557.557,0,0,1,.782,0L15.5,9.667a.551.551,0,0,1,.016.761l-3.326,3.333a.552.552,0,1,1-.782-.78Z"
                                    transform="translate(-11.246 -6.196)"
                                  />
                                </svg>
                              </ListGroupItem>

                              <ListGroupItem
                                active={dropValue == 3}
                                onClick={() => setDropValue(3)}
                              >
                                Operators
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="4.418"
                                  height="7.726"
                                  viewBox="0 0 4.418 7.726"
                                >
                                  <path
                                    id="Icon_ionic-ios-arrow-forward"
                                    data-name="Icon ionic-ios-arrow-forward"
                                    d="M14.332,10.058,11.409,7.137a.55.55,0,0,1,0-.78.557.557,0,0,1,.782,0L15.5,9.667a.551.551,0,0,1,.016.761l-3.326,3.333a.552.552,0,1,1-.782-.78Z"
                                    transform="translate(-11.246 -6.196)"
                                  />
                                </svg>
                              </ListGroupItem>
                              <ListGroupItem
                                active={dropValue == 2}
                                onClick={() => setDropValue(2)}
                              >
                                Constant
                              </ListGroupItem>
                            </ListGroup>
                          </Col>
                          {dropValue == 1 && (
                            <Col md="6">
                              <ListGroup>
                                <ListGroupItem tag="button" disabled>
                                  Select Value
                                </ListGroupItem>

                                {data.map((value) => {
                                  const {
                                    feesId = 0,
                                    labelName = '',
                                    feeVariableTypeId = 0,
                                    isNonDisplayVariable = false,
                                  } = value;
                                  if (
                                    feeVariableTypeId == 3 &&
                                    isNonDisplayVariable
                                  ) {
                                    return (
                                      <ListGroupItem
                                        key={feesId}
                                        active={subdropValue == feesId}
                                        value={feesId}
                                        data-type="variable"
                                        data-list_value={feesId}
                                        data-list_label={labelName}
                                        onClick={(e) => {
                                          setSubDropValue(feesId);
                                          formListChange(e);
                                        }}
                                        style={{ cursor: 'pointer' }}
                                      >
                                        {labelName}
                                      </ListGroupItem>
                                    );
                                  }
                                })}
                              </ListGroup>
                            </Col>
                          )}
                          {dropValue == 2 && (
                            <Col md="6">
                              <ListGroup>
                                <ListGroupItem tag="button" disabled>
                                  Type Value
                                </ListGroupItem>
                                <Input
                                  type="number"
                                  name="constant"
                                  id="constant"
                                  placeholder="Enter Constant"
                                  onKeyPress={(e) => {
                                    if (e.key === 'Enter') formValueChange(e);
                                  }}
                                />
                              </ListGroup>
                            </Col>
                          )}
                          {dropValue == 3 && (
                            <Col md="6">
                              <ListGroup>
                                <ListGroupItem tag="button" disabled>
                                  Select Value
                                </ListGroupItem>

                                {operator.map((value) => {
                                  const { operatorId = 0, operatorName = '' } =
                                    value;
                                  return (
                                    <ListGroupItem
                                      active={subdropValue == operatorId}
                                      value={operatorId}
                                      data-type="operator"
                                      data-list_value={operatorId}
                                      data-list_label={operatorName}
                                      onClick={(e) => {
                                        setSubDropValue(operatorId);
                                        formListChange(e);
                                      }}
                                      style={{ cursor: 'pointer' }}
                                    >
                                      {operatorName}
                                    </ListGroupItem>
                                  );
                                })}
                              </ListGroup>
                            </Col>
                          )}
                        </Row>
                      ) : (
                        ''
                      )}
                    </div>
                    {showValue &&
                      showValue.map((data, i) => {
                        return (
                          <div className="design-model" key={i}>
                            {`${data.labelName}  `}

                            <i
                              onClick={() => removeShowValue(i)}
                              style={{ cursor: 'pointer' }}
                              className="far fa-times-circle"
                            ></i>
                          </div>
                        );
                      })}
                    {flag && (
                      <p
                        className="error"
                        style={{ marginLeft: '5px', fontSize: '90%' }}
                      >
                        Please enter valid / complete equation.
                      </p>
                    )}
                  </section>
                )}
              </Col>
              {values.feeVariableTypeId == 1 && (
                <Col md={12}>
                  <FormGroup>
                    <Label for="price">Fee ($)</Label>
                    <InputGroup>
                      
                        <InputGroupText>$</InputGroupText>
                      
                      <Input
                        type="text"
                        name="price"
                        id="price"
                        placeholder="Fee"
                        invalid={errors.price && touched.price ? true : false}
                        onChange={(event) => {
                          setFieldTouched('price', true);
                          handleChange(event);
                        }}
                        value={values.price}
                      />
                      <FormFeedback>
                        {errors.price && touched.price ? errors.price : ''}
                      </FormFeedback>
                    </InputGroup>
                  </FormGroup>
                </Col>
              )}
              {values.feeVariableTypeId == 2 && (
                <Col md={12}>
                  <FormGroup>
                    <Label for="price">Fee ($)</Label>
                    <InputGroup>
                      
                        <InputGroupText>$</InputGroupText>
                      
                      <Input
                        type="text"
                        name="price"
                        id="price"
                        placeholder="Fee"
                        invalid={errors.price && touched.price ? true : false}
                        onChange={(event) => {
                          setFieldTouched('price', true);
                          handleChange(event);
                        }}
                        value={values.price}
                      />
                      <FormFeedback>
                        {errors.price && touched.price ? errors.price : ''}
                      </FormFeedback>
                    </InputGroup>
                  </FormGroup>
                </Col>
              )}
              {values.feeVariableTypeId == 3 && (
                <>
                  <Col md={12}>
                    <FormGroup check>
                      <Label check for="isNonDisplayVariable">
                        <Input
                          type="checkbox"
                          id="isNonDisplayVariable"
                          name="isNonDisplayVariable"
                          checked={values.isNonDisplayVariable}
                          onChange={handleChange}
                        />
                        This variable should be used by another variable.
                      </Label>
                    </FormGroup>
                  </Col>
                  {/* <Col md={6}>
                    <FormGroup check>
                      <Label check for="addToagencyfee">
                        <Input
                          type="checkbox"
                          id="addToagencyfee"
                          name="addToagencyfee"
                          checked={values.addToagencyfee}
                          onChange={handleChange}
                        />
                        Add to Agency fee{" "}
                      </Label>
                    </FormGroup>
                  </Col> */}
                </>
              )}
            </Row>
          </ModalBody>
          <ModalFooter>
            <Button color="primary" type="submit" disabled={flag}>
              {btnLoading && <CustomLoader loading={btnLoading} />}
              {isAdd ? 'Create' : 'Update'}
            </Button>
            <Button color="secondary" onClick={toggle}>
              Cancel
            </Button>
          </ModalFooter>
        </Form>
      </Modal>
    </div>
  );
};

export default CreateVariableDialog;

